var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocument = function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1A2550",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.833 17.5c-.92 0-1.666-.746-1.666-1.667V4.167c0-.92.746-1.667 1.666-1.667h5.834l4.166 4.167v9.166c0 .92-.746 1.667-1.666 1.667z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    d: "M10.833 2.5v5h5"
  })));
};
export default SvgDocument;